import type { Role } from './models/roles';

const roleInheritance: Role[] = ['admin', 'contributor', 'reader'];

export default function expandRoles(roles: string[]) {
  return new Set(
    roles.flatMap((role) => {
      const index = roleInheritance.indexOf(role as Role);
      if (index === -1) {
        return [];
      }
      return roleInheritance.slice(index);
    }),
  );
}
